import apiService from '@/api/request';
import {
  USERINFO, MEMBERORDERLIST, USERMEMBERCENTER, COUPONS, USERSTATUS, WALLETBANK, FLOWFILTERING, CURRENCYLIST,
} from '../mutation-type';
// 登录获取用户信息
export const getUserInfo = async ({ commit, state }) => {
  console.log('getUserInfo', state.user.userToken);
  if (!state.user.userToken) return;
  const res = await apiService.UserInformation({ userToken: state.user.userToken });
  if (res.status === 1) {
    commit(USERINFO, res.data);
  }
};
// 获取用户状态
export const getUserStatus = async ({ commit, state }) => {
  console.log('getUserInfo', state.user.userToken);
  if (!state.user.userToken) return;
  const res = await apiService.UserStatus({ userToken: state.user.userToken });
  if (res.status === 1) {
    commit(USERSTATUS, res.data);
  }
};
export const getUserMemberCenter = async ({ commit, state }) => {
  console.log('getUserMemberCenter:', state.user.userToken);
  if (!state.user.userToken) return;
  const res = await apiService.UserMemberCenter({ userToken: state.user.userToken });
  if (res.status === 1) {
    commit(USERMEMBERCENTER, res.data);
  }
};

export const getMemberOrderList = async ({ commit, state }) => {
  console.log('MemberOrderList:', state.user.userToken);
  if (!state.user.userToken) return;
  const res = await apiService.MemberOrderList({ userToken: state.user.userToken });
  if (res.status === 1) {
    commit(MEMBERORDERLIST, res.data);
  }
};

export const getCoupons = async ({ commit, state }, data) => {
  console.log('getCoupons:', state.user.userToken);
  if (!state.user.userToken) return;
  const res = await apiService.Coupons({
    userToken: state.user.userToken,
    useStatus: data.useStatus,
  });
  if (res.status === 1) {
    commit(COUPONS, res.data);
  }
};

export const getWalletBank = async ({ commit, state }) => {
  console.log('getWalletBank:', state.user.userToken);
  if (!state.user.userToken) return;
  const res = await apiService.GetWalletBank({
    userToken: state.user.userToken,
    bankType:2
  });
  console.log('getWalletBank', res);
  if (res.status === 1) {
    commit(WALLETBANK, res.data.listWiretransferInfo);
  }
};

export const getFlowFiltering = async ({ commit, state }) => {
  console.log('getFlowFiltering', state.user.userToken);
  if (!state.user.userToken) return;
  const res = await apiService.getFlowFiltering({
    userToken: state.user.userToken,
  });
  if (res.status === 1) {
    commit(FLOWFILTERING, res.data);
  }
};
// 获取币种
export const getCurrency = async ({ commit }) => {
  const res = await apiService.CurrencyType();
  if (res.status === 1) {
    commit(CURRENCYLIST, res.data.listCurrencyType);
  }
};
